import React from "react";
import { Link } from "react-router-dom";
import { ageCalculate } from "../utils/utils.js";

export const photoApprovalColumns = ({
  PAGE_SIZE,
  viewPhoto
}) => [
    {
      label: "S.No",
      width: 50,
      render: (row, index, page) =>
        (page - 1) * PAGE_SIZE + index + 1,
    },

    {
      label: "Profile ID",
      width: 120,
      render: (row) => (
        <div className="profile-id">
          <strong>{row.profile_id || "N/A"}</strong>
        </div>
      ),
    },
    {
      label: "User Details",
      render: (row) => (
        <div className="userdet">
          <div>
            <i className="far fa-user" /> {row.name || "-"}
          </div>
          <div>
            <i className="far fa-mobile" /> {row.mobile || "-"}
          </div>
          <div style={{ wordBreak: "break-all" }}>
            <i className="far fa-envelope" /> {row.email || "-"}
          </div>
          <div>
            <i className="far fa-mars" /> {row.gender || "-"}
          </div>
          <div>
            <i className="far fa-calendar-alt" />{" "}
            {row.dob ? `${ageCalculate(row.dob)} Yrs old` : "-"}
          </div>
        </div>
      ),
    },
    {
      label: "View Photo",

      render: (row) => (
        <button
          type="button"
          className="btn btn-sm"
          style={{
            backgroundColor: "#108908",
            color: "#ffffff",
            padding: "7px 16px",
            borderRadius: "20px",
            fontSize: "13px",
            fontWeight: "600",
            border: "none",
            display: "inline-flex",
            alignItems: "center",
            gap: "6px",
            cursor: "pointer",
            transition: "all 0.2s ease-in-out",
            whiteSpace: "nowrap",
          }}
          onClick={() => viewPhoto(row)}
        >
          {/* <i className="fa fa-camera" style={{ fontSize: "13px" }} /> */}
          View Photo
        </button>
      ),
    },


  ];
